export const FEATURE_FLAGS = {
  enableGlobalSearchSuggestions: true,
  enableMenuSearch: true,
  enableAdsensePlaceholders: false,
  enableMonetizationAds: false,
  enableToolPersistence: true,
  enableGlobalLoader: true,
};

const parseBoolean = (value) => {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') {
    if (value.toLowerCase() === 'true') return true;
    if (value.toLowerCase() === 'false') return false;
  }
  return undefined;
};

export const resolveFeatureFlags = (configFlags = {}) => {
  const runtimeEnv = typeof window !== 'undefined' ? window.__APP_ENV__ || {} : {};

  return Object.keys(FEATURE_FLAGS).reduce((acc, key) => {
    const envKey = `REACT_APP_FEATURE_${key.replace(/([A-Z])/g, '_$1').toUpperCase()}`;
    const envValue = parseBoolean(process.env[envKey]);
    const runtimeValue = parseBoolean(runtimeEnv[envKey]);
    const configValue = parseBoolean(configFlags[key]);

    acc[key] = runtimeValue ?? envValue ?? configValue ?? FEATURE_FLAGS[key];
    return acc;
  }, {});
};
